import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "container"]

  connect() {
    this.timeout = null
    this._onClickOutside = this._handleClickOutside.bind(this)
    this._onKeydown = this._handleKeydown.bind(this)
    document.addEventListener("click", this._onClickOutside)
    document.addEventListener("keydown", this._onKeydown)
    this.selectedIndex = -1
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
    document.removeEventListener("keydown", this._onKeydown)
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length === 0) {
      this.timeout = setTimeout(() => {
        this._fetchRecent()
      }, 100)
      return
    }

    if (query.length < 2) {
      this._hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this._fetchResults(query)
    }, 250)
  }

  focus() {
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  select() {
    this._hideResults()
    this.inputTarget.value = ""
  }

  _fetchResults(query) {
    this._inject(`/search?q=${encodeURIComponent(query)}`)
  }

  _fetchRecent() {
    this._inject("/search")
  }

  _inject(url) {
    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      }
    })
    .then(response => response.text())
    .then(html => {
      this.resultsTarget.innerHTML = html
      this._showResults()
      this.selectedIndex = -1
    })
  }

  _showResults() {
    this.containerTarget.classList.remove("hidden")
  }

  _hideResults() {
    this.containerTarget.classList.add("hidden")
    this.selectedIndex = -1
  }

  _handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this._hideResults()
    }
  }

  _handleKeydown(event) {
    // Only handle keys when this instance's input is focused
    if (document.activeElement !== this.inputTarget) return

    // Escape to close
    if (event.key === "Escape") {
      event.preventDefault()
      this._hideResults()
      this.inputTarget.blur()
      return
    }

    // Keyboard navigation within results
    if (this.containerTarget.classList.contains("hidden")) return

    const items = this.containerTarget.querySelectorAll(".search-result-item")
    if (!items.length) return

    if (event.key === "ArrowDown") {
      event.preventDefault()
      this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1)
      this._highlightItem(items)
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
      this._highlightItem(items)
    } else if (event.key === "Enter" && this.selectedIndex >= 0) {
      event.preventDefault()
      items[this.selectedIndex].click()
    }
  }

  _highlightItem(items) {
    items.forEach((item, i) => {
      item.classList.toggle("bg-hover", i === this.selectedIndex)
    })
  }
}
